import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useMergeFields } from '../../../hooks/useTemplates';

function MergeFieldPicker({ onInsert }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { groups, isLoading } = useMergeFields();

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    function handleClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  const handleFieldClick = (field) => {
    onInsert(`{{${field}}}`);
    setIsOpen(false);
  };

  const handleHelperClick = (snippet) => {
    onInsert(snippet);
    setIsOpen(false);
  };

  const dateHelpers = [
    { label: 'short — Jan 1, 2026', snippet: '{{formatDate reservation.checkIn "short"}}' },
    { label: 'long — Friday, January 1, 2026', snippet: '{{formatDate reservation.checkIn "long"}}' },
    { label: 'date — 01/01/2026', snippet: '{{formatDate reservation.checkIn "date"}}' },
    { label: 'monthDay — January 1', snippet: '{{formatDate reservation.checkIn "monthDay"}}' },
    { label: 'monthDayShort — Jan 1', snippet: '{{formatDate reservation.checkIn "monthDayShort"}}' },
    { label: 'weekday — Friday', snippet: '{{formatDate reservation.checkIn "weekday"}}' },
    { label: 'weekdayShort — Fri', snippet: '{{formatDate reservation.checkIn "weekdayShort"}}' },
    { label: 'monthYear — January 2026', snippet: '{{formatDate reservation.checkIn "monthYear"}}' },
    { label: 'iso — 2026-01-01', snippet: '{{formatDate reservation.checkIn "iso"}}' },
    { label: 'full — Friday, January 1, 2026 at 3:00 PM', snippet: '{{formatDate reservation.checkIn "full"}}' },
    { label: 'time — 3:00 PM', snippet: '{{formatDate reservation.checkIn "time"}}' },
  ];

  const otherHelpers = [
    { label: 'formatCurrency (totalAmount) — $750.00', snippet: '{{formatCurrency reservation.totalAmount}}' },
    { label: 'formatCurrency (payment) — $750.00', snippet: '{{formatCurrency payment.amount}}' },
    { label: 'uppercase — APPROVED', snippet: '{{uppercase reservation.status}}' },
  ];

  return (
    <div className="merge-field-picker" ref={dropdownRef}>
      <button
        type="button"
        className="merge-field-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        Insert Field
        <ChevronDown size={14} />
      </button>

      {isOpen && (
        <div className="merge-field-dropdown">
          {isLoading ? (
            <div className="merge-field-loading">Loading fields...</div>
          ) : (
            <>
              {groups.map((group) => (
                <div key={group.name} className="merge-field-group">
                  <div className="merge-field-group-label">{group.name}</div>
                  {group.fields.map((field) => (
                    <button
                      key={field}
                      type="button"
                      className="merge-field-item"
                      onClick={() => handleFieldClick(field)}
                    >
                      {field}
                    </button>
                  ))}
                </div>
              ))}
              <div className="merge-field-group">
                <div className="merge-field-group-label">Date Formats</div>
                {dateHelpers.map((h) => (
                  <button
                    key={h.label}
                    type="button"
                    className="merge-field-item"
                    onClick={() => handleHelperClick(h.snippet)}
                  >
                    {h.label}
                  </button>
                ))}
              </div>
              <div className="merge-field-group">
                <div className="merge-field-group-label">Other Helpers</div>
                {otherHelpers.map((h) => (
                  <button
                    key={h.label}
                    type="button"
                    className="merge-field-item"
                    onClick={() => handleHelperClick(h.snippet)}
                  >
                    {h.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MergeFieldPicker;
